import { FLAGS, useFlag } from '@iheartjane/feature-flags';
import { CardCarousel, SpecialCard } from '@iheartjane/menu';
import { Flex } from '@iheartjane/reefer';

import type {
  ComplianceLanguageSettings,
  EmbeddedMenuRow,
  MenuRow,
} from '@jane/business-admin/types';
import { SpecialCard as OldSpecialCard } from '@jane/shared-ecomm/components';
/* eslint-disable-next-line no-restricted-imports */
import type { Store, StoreSpecial } from '@jane/shared/models';

import { ListContainer } from './ListContainer';
import {
  EmbedCodeButton,
  HeaderEditButton,
  HeaderToggle,
} from './ListItemHeaders';
import { getRowLabel } from './utils';

interface Props {
  complianceLanguageSettings?: ComplianceLanguageSettings;
  currentStoreSpecials: StoreSpecial[];
  embeddedMenuRow?: EmbeddedMenuRow | null;
  openEmbedRowModal?: (menuRow: MenuRow, row?: EmbeddedMenuRow | null) => void;
  openMenuRowModal: (row: MenuRow) => void;
  row: MenuRow;
  showEmbedButton?: boolean;
}
export const SpecialsListItem = ({
  complianceLanguageSettings,
  currentStoreSpecials,
  embeddedMenuRow,
  openEmbedRowModal,
  openMenuRowModal,
  row,
  showEmbedButton,
}: Props) => {
  const specialsRedesignMenu = useFlag(FLAGS.c3SpecialsRedesignMenu);
  const rowLabel = getRowLabel(row);

  return (
    <ListContainer rowEnabled={!!row.enabled}>
      <CardCarousel
        afterHeader={
          <Flex alignItems="center">
            {showEmbedButton && openEmbedRowModal && (
              <EmbedCodeButton
                hasEmbedCode={!!embeddedMenuRow}
                onClick={() => openEmbedRowModal(row, embeddedMenuRow)}
              />
            )}
            <HeaderEditButton
              onOpenMenuRow={() => openMenuRowModal(row)}
              showCTAButton={false}
            />
          </Flex>
        }
        beforeHeader={
          <HeaderToggle
            row={row}
            rowLabel={rowLabel}
            itemsLength={0}
            showProductsCTA={false}
          />
        }
        name={rowLabel}
        mode="fixed"
        cardWidth={315}
        cardHeight={240}
        cardWidthMobile={212}
        cardHeightMobile={328}
        mb={row.enabled ? 40 : 0}
      >
        {row.enabled &&
          currentStoreSpecials
            .filter((special) => !special.hidden_from_row)
            .map((special) => (
              <CardCarousel.Card key={`${special.id}`}>
                {specialsRedesignMenu ? (
                  <SpecialCard
                    key={special.id}
                    customSpecialBadge={special?.custom_badge}
                    discountAmount={special?.discount_amount}
                    discountType={special?.discount_type}
                    imageSrc={special?.photo?.urls?.original}
                    reservationModes={special?.reservation_modes}
                    specialType={special?.special_type}
                    storeComplianceLanguageSettings={complianceLanguageSettings}
                    title={special.title}
                  />
                ) : (
                  <OldSpecialCard
                    special={special}
                    store={
                      {
                        store_compliance_language_settings:
                          complianceLanguageSettings,
                      } as Store
                    }
                  />
                )}
              </CardCarousel.Card>
            ))}
      </CardCarousel>
    </ListContainer>
  );
};
